import { MailDataInfo } from "src/types";
import EventBus from "../event-bus";

const receiveMessageHook = new EventBus<MailDataInfo>("receiveMessageHook");

export default receiveMessageHook;
